import ResizeTable from './ResizeTable'
import React, { useState, useEffect } from 'react';
import HeaderMutliApprove from './HeaderMutliApprove';
import requester from '../../../lib/requester';
import { UpCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import '../style/style.css'
import FullScreenLoader from '../../../component/loading/FullScreenLoader';
import { Modal, Button } from 'antd';
import Datatable from '../../../component/table/dataTable';

const ScrollToTop = () => {

    const [showScroll, setShowScroll] = useState(false)

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 300) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 300) {
            setShowScroll(false)
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('scroll', checkScrollTop)

    return (
        <span>
            <UpCircleOutlined className="scrollTop" onClick={scrollTop} style={{ height: 40, display: showScroll ? 'flex' : 'none' }} />
        </span>
    );
}

const MultiApprove = () => {
    const [finalData, setFinalData] = useState([])
    const [columns, setColumns] = useState([])
    const [lovMaster, setLovMaster] = useState({ awbNo: [], claimNumber: [], coverLetterNo: [], skpPrincipalNo: [] })
    const [stickyHeader, setStickyHeader] = useState(true)
    const [dataSource, setDataSource] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const initialColumn = [
        {
            title: "NO",
            dataIndex: 'no',
            width: 50,
        },
        {
            title: 'Approve',
            dataIndex: 'approve',
            width: 70,
        },
        {
            title: 'Revise',
            dataIndex: 'revise',
            width: 70,
        },
        {
            title: 'Reject',
            dataIndex: 'reject',
            width: 70,
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            width: 200,
        },
        {
            title: 'Cover Letter No',
            dataIndex: 'cover_letter_no',
            width: 200,
        },
        {
            title: 'Claim No',
            dataIndex: 'claim_number',
            width: 130,
        },
        {
            title: 'Ref No',
            dataIndex: 'ref_no',
            width: 100,
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            width: 200,
        },
        {
            title: 'Program Type',
            dataIndex: 'program_type',
            width: 200,
        },
        {
            title: 'Nilai Dpp',
            dataIndex: 'dpp',
            width: 200,
        },
        {
            title: 'Nilai Ppn',
            dataIndex: 'ppn',
            width: 200,
        },
        {
            title: 'Total Claim',
            dataIndex: 'total_claim',
            width: 200,
        },

        {
            title: 'PPh Rate',
            dataIndex: 'pph_rate',
            width: 200,
        },
        {
            title: 'Nilai PPh',
            dataIndex: 'pph',
            width: 200,
        },
        {
            title: 'Net Claim',
            dataIndex: 'nett_claim',
            width: 200,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            width: 200,
        },
    ]

    // const dataSource = Array.from({ length: 30 }).map((_, index) => ({
    //     key: index + 1,
    //     no: index + 1,
    //     approve: false,
    //     revise: false,
    //     reject: false,
    //     reason: "",
    //     cover_letter_no: 'CL001',
    //     claim_number: 'C001',
    //     ref_no: 'R001' + index + Math.random(),
    //     customer_name: 'John Doe',
    //     program_type: 'Type A',
    //     dpp: 123 * index + Math.random(),
    //     ppn: 123 * index + Math.random(),
    //     total_claim: 123 * index + Math.random(),
    //     pph: '10',
    //     pph: 123 * index + Math.random(),
    //     net_claim: 123 * index + Math.random(),
    //     action: ''
    // }));

    const dataHeader = () => {
        // Menghitung jumlah data dengan status approve=true
        const totalApprove = finalData.filter((item) => item.approve === true).length;

        // Menghitung jumlah data dengan status reject=true
        const totalReject = finalData.filter((item) => item.reject === true).length;

        // Menghitung jumlah data dengan status revise=true
        const totalRevise = finalData.filter((item) => item.revise === true).length;

        return {
            totalApprove: totalApprove,
            totalReject: totalReject,
            totalRevise: totalRevise
        }
    }

    useEffect(() => {
        getMaster()
    }, [])

    const getMaster = async () => {
        const url = '/api/traces/v1/claim/multiapprove/lov'
        setIsLoading(true)
        try {
            await requester.getTraces(url, {
                success: function (response) {
                    const res = response.data.data;
                    setLovMaster(res)
                    setIsLoading(false)
                },
                error: function (e) {
                    console.log(e);
                    setIsLoading(false)
                },
            });
        } catch (error) {
            console.log("error L: ", error)
            setIsLoading(false)
        }
    }

    const search = async (e) => {
        const url = '/api/traces/v1/claim/multiapprove/search '
        setIsLoading(true)
        try {
            await requester.postTraces(url, e, {
                success: function (response) {
                    const res = response.data.data;
                    const newMaping = res.map((value, index) => {
                        return {
                            key: index + 1,
                            no: index + 1,
                            "approve": value.approve ? value.approve : false,
                            "revise": value.revise ? value.revise : false,
                            "reject": value.reject ? value.reject : false,
                            "reason": value.reason ? value.reason : "",
                            "cover_letter_no": value.cover_letter_no,
                            "claim_id": value.claim_id,
                            "claim_number": value.claim_number,
                            "ref_no": value.ref_no,
                            "customer_name": value.customer_name,
                            "program_type": value.program_type,
                            "dpp": value.dpp,
                            "ppn": value.ppn,
                            "total_claim": value.total_claim,
                            "pph_rate": value.pph_rate,
                            "pph": value.pph,
                            "nett_claim": value.nett_claim,
                        }
                    })
                    setDataSource(newMaping)
                    setIsLoading(false)
                },
                error: function (e) {
                    console.log(e);
                    setIsLoading(false)
                },
            });
        } catch (error) {
            console.log("error L: ", error)
            setIsLoading(false)
        }
    }

    const submit = async (data) => {
        const url = '/api/traces/v1/claim/multiapprove/submit'
        setIsLoading(true)
        const param = data.map((value, index) => {
            return {
                "claim_number": value.claim_number,
                "approve": value.approve,
                "reject": value.reject,
                "revise": value.revise,
                "reason": value.reason
            }
        })
        try {
            await requester.postTraces(url, param, {
                success: function (response) {
                    const mes = response.data.message
                    const status = response.data.status
                    setIsLoading(false)

                    if (status) {
                        success(mes)
                    } else {
                        const res = response.data.data.validatedData;
                        const newMap = res && res.length ? res.map((value, index) => {
                            return {
                                "NOTES":value.notes,
                                "APPROVE": value.approve,
                                "REVISE": value.revise,
                                "REJECT": value.reject,
                                "REASON": value.reason,
                                "COVER LETTER NO": value.cover_letter_no,
                                "CLAIM NUMBER": value.claim_number,
                                "REF NO": value.ref_no,
                                "CUSTOMER NAME": value.customer_name,
                                "PROGRAM TYPE": value.program_type,
                                "DPP": value.dpp,
                                "PPN": value.ppn,
                                "TOTAL CLAIM": value.total_claim,
                                "PPH RATE": value.pph_rate,
                                "PPH": value.pph,
                                "NET CLAIM": value.nett_claim,
                            }
                        }) : []
                        error(mes, newMap)
                    }
                },
                error: function (e) {
                    console.log(e.response.data.message);
                    setIsLoading(false)
                    error(e.response ? e.response.data.message : "Error")
                },
            });
        } catch (error) {
            console.log("error L: ", error)
            setIsLoading(false)
            error(error.response ? error.response.data.message : "Error")
        }
    }
    const success = (mes) => {
        Modal.success({
            content: (
                <>
                    <p>
                        {mes}
                    </p>
                </>
            ),
            zIndex: 1004,
            onOk: () => {
                // submit(dataToSubmit)
                window.location.reload()
            }
        });
    };

    const error = (error, download) => {
        Modal.error({
            content: (
                <>
                    <p>
                        {error}
                    </p>
                    <div className='d-flex justify-content-center'>
                        <Button type="primary" shape="round" icon={<DownloadOutlined />} size='medium' onClick={() => requester.exportToXlsx(download, 'Data invalid')}>
                            Download invalid data
                        </Button>
                    </div>
                </>
            ),
            zIndex: 1004,
            onOk: () => {
                // submit(dataToSubmit) 
            }
        });
    };
    return (
        <>
            <ScrollToTop />
            <HeaderMutliApprove
                columns={initialColumn}
                selectedColumn={(e) => { setColumns(e) }}
                dataHeader={dataHeader()}
                finalData={finalData}
                lov={lovMaster}
                stickyHeader={(e) => setStickyHeader(e)}
                submit={(e) => submit(e)}
                search={(e) => { setDataSource([]); search(e) }}
                dataProps={dataSource}
            />
            {
                dataSource && dataSource.length ?
                    <ResizeTable
                        dataProps={dataSource}
                        columnsProps={columns}
                        dataToApi={(e) => setFinalData(e)}
                        stickyHeader={stickyHeader}
                    />
                    : 
                    <Datatable data={[]}/>
            }
            <FullScreenLoader isLoading={isLoading} />
        </>
    )
}

export default MultiApprove